import HeaderPageErreur from "../components/APRHN/HeaderPageErreur";
import ErreurTechnique from "../components/APRHN/ErreurTechnique";
import Footer from "../components/APRHN/Footer";
import "./pageErreurTechniqueAPRHN.css";

function PageErreurTechniqueAPRHN() {
  return (
    <div data-testid="page-erreur-technique-aprhn" className="Erreur page-erreur-technique-aprhn">
      <HeaderPageErreur />
      <ErreurTechnique />
      <Footer positionPageFooter="erreurs" />
    </div>
  );
}

export default PageErreurTechniqueAPRHN;
